import React from 'react';

const CategoryItem = ({ category, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 flex justify-between items-center hover:shadow-md transition-shadow">
      <div>
        <h4 className="font-medium text-gray-800">{category.name}</h4>
        {category.description && (
          <p className="text-sm text-gray-500 mt-1">{category.description}</p>
        )}
      </div>
      <div className="flex space-x-2">
        <button
          onClick={() => onEdit(category)}
          className="p-1 text-blue-500 hover:text-blue-700 transition-colors"
        >
          ✏️
        </button>
        <button
          onClick={() => onDelete(category.name)}
          className="p-1 text-red-500 hover:text-red-700 transition-colors"
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default CategoryItem;